import { StaticBaseDao } from '@/dao';
import { GPIOReading, AttachGPIOReadingToRequest } from '@/objects/generated';

export class GPIOReadingDao extends StaticBaseDao {
    public static async SaveGunstartGPIOReadingForGroupStart(
        EventID: number,
        GroupID: number,
        reading: GPIOReading,
    ): Promise<GPIOReading | null> {
        return this.BaseFetch(
            GPIOReading,
            `GPIOReading/SaveGunstartReadingForGroupStart` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (GroupID == undefined ? '' : `GroupID=${GroupID}`),
            'POST',
            reading,
        );
    }
    public static async AttachGPIOReadingTo(EventID: number, request: AttachGPIOReadingToRequest): Promise<GPIOReading | null> {
        return this.BaseFetch(
            GPIOReading,
            `GPIOReading/AttachGPIOReadingTo` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            request,
        );
    }
}
